export const userRoles = [
    {
        value: 2,
        text: 'administrator',
    },
    {
        value: 3,
        text: 'editor',
    }
];